<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Φόρτωση τιμολογίων για {{distributor.Name}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12" sm="6"
            >
             <v-combobox
                label="Προμηθευτής*"
                v-model="distributor"
                required
                :items="dists"
                item-text="Name"
                return-object
                ></v-combobox>
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="6" sm="4">
            <v-file-input
                  chips
                  dense
                  prepend-icon="mdi-microsoft-excel"
                  accept=".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Τιμολόγια"
                  placeholder="Επιλέξτε αρχείο τιμολογίων"
                  v-model="csvFile"
                ></v-file-input>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                label="Τύπος αρχείου*"
                v-model="csvDistFormat"
                hint="Δομή προμηθευτή"
                persistent-hint
                required
                :items="csvDistFormats"
                ></v-combobox>
            </v-col>
            <v-col>
                <v-btn @click="uploadCSV" icon><v-icon>mdi-update</v-icon></v-btn>
              </v-col>
            
          </v-row>
        </v-container>
        <small>* Υποχρεωτικά πεδία</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="resetInvoice"
        >
          Εκκαθάριση
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click.native="close"
        >
          Κλεισιμο
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          :disabled="saveDisable"
          @click="createInvoice"
        >
          Αποθηκευση
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

  export default {

   computed: {
      dateRangeText () {
        return new Date(this.invoiceForm.Date).toISOString().substr(0,10);
      },
    },
    props: {
        dialog: {
        default: false
      },
        dists: {
          required: true, default: []
      },
    },
    data() {
      return {
        menu: false,
        csvDistFormats: ["intercars", "camion", "fapi"],
        csvDistFormat: null,
        distributor: {Name:""},
        series: [],
        saveDisable: false,
        addPayment: false,
        vat: 0.24,
        kindItems: [
          {text: 'Ανταλλακτικά', value: 0},
          {text: 'Αναλώσιμα', value: 1},
          {text: 'Βενζίνη', value: 2},
          {text: 'Τρόφιμα', value: 3},
          {text: 'Εργαλεία', value: 4},
        ],
        paymItems: [
          {text: "Κατάθεση σε τράπεζα", value: 1},
          {text: "Αντικαταβολή", value: 2},
          {text: "Μετρητά", value: 3},
          {text: "Επιταγή", value: 4},
          {text: "Επί Πιστώσει", value: 5},
          {text: "Web Banking", value: 6},
          {text: "POS / e-POS", value: 7},
       ],
        vatItems: [
          {text: '0', value: 0},
          {text: '6', value: 0.06},
          {text: '13', value: 0.13},
          {text: '24', value: 0.24},
       ],
        invoTypeItems: [
          {text: "Τιμολόγιο Πώλησης", value: '1.1'},
          {text: "Τιμολόγιο Παροχής Υπηρεσιών", value: '2.1'},
          {text: "Πιστωτικό Τιμολόγιο", value: '5.1'},
          {text: "Πιστωτικό Τιμολόγιο Μη Συσχετιζόμενο", value: '5.2'},
       ],
     }
    },
    watch: {
      'invoiceForm.NetValue' (newVal) {
        this.invoiceForm.VatValue = +((newVal * this.vat).toFixed(2));
        this.invoiceForm.TotalValue = Number((newVal + this.invoiceForm.VatValue).toFixed(2));

      },
      'vat' (newVal) {
        this.invoiceForm.VatValue = +((this.invoiceForm.NetValue * newVal).toFixed(2));
        this.invoiceForm.TotalValue = Number((this.invoiceForm.VatValue + this.invoiceForm.NetValue).toFixed(2));

      },
      cid: async function(newVal) {
        const response = await this.$api.get("/suppliers/"+newVal+"/invoices/series");
        this.series = response.data;
      }
    },

    async mounted() {
        //if (this.cid) {
        //const response = await this.$api.get("/suppliers/"+this.cid+"/invoices/series");
        //this.series = response.data;
       // this.invoiceForm.SeriesCode = this.series[0];
       //}
    },
    methods: {
        close() {
        //this.resetInvoice();
        this.$emit('update:dialog', false)
      },
      async uploadCSV() {
      if (this.csvFile) {
        try {
          var formData = new FormData();
          formData.append("invoices_file", this.csvFile);
          formData.append("dist_afm", this.distributor.Afm);
          formData.append("csv_format", this.csvDistFormat);
          let resp = await this.$api.post("/invoices/purchases/upload", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          if (resp.status == 201) {
            this.csvFile = null;
            this.distributor = {Name: ""};
            this.csvDistFormat = null;
            alert("Οι πωλήσεις ενημερώθηκαν");
          } else {
            alert("Σφάλμα ενημέρωσης");
            console.log(resp);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
      resetInvoice() {
        //Object.assign(this.invoiceForm, this.newInvoiceForm);
        this.saveDisable = false;
        this.addPayment = false;

      },
    },
  }

</script>
